export default __webpack_public_path__ + "static/media/AFRO-MOJO.3b59ccee.png";